const columns = [
  {
    name: 'Congregations',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Total Incidents',
    selector: (row) => row?.new_incidents,
    sortable: true,
    sortField: 'new_incidents',
  },
  {
    name: 'Incident Closed',
    selector: (row) => row?.incident_closed,
    sortable: true,
    sortField: 'incident_closed',
  },
  {
    name: 'Open Incident',
    selector: (row) => row?.remaining_incidents,
    sortable: true,
    sortField: 'remaining_incidents',
  }, 
  
];
const mobileColumns = [
  {
    name: 'Congregations',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Total Incidents',
    selector: (row) => row?.new_incidents,
    sortable: true,
    sortField: 'new_incidents',
  },
];

export { columns, mobileColumns };
